export default __webpack_public_path__ + "static/pepsico-4ea6391fc3eac5ae67158448c8ef75be.png";